import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { defaultDoc } from '../share/defaultDoc';

export interface PrimaryCauseOfFailure {
  readonly name: string;
  readonly id: string;
  readonly discipline: number;
  readonly sort: number;
  readonly isActive: boolean;
  readonly dateModified: string;
}

export const primaryCauseOfFailureSchema: RxJsonSchema<PrimaryCauseOfFailure> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};

export type PrimaryCauseOfFailureCollection = RxCollection<PrimaryCauseOfFailure> | null;
export type PrimaryCauseOfFailureDocument = RxDocument<PrimaryCauseOfFailure>;

export const primaryCauseOfFailurePullQueryBuilder = (document: PrimaryCauseOfFailure) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query primaryCauseOfFailureFeed($lastRequested: DateTime) {
      primaryCauseOfFailureFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};

export default {};
